import React from 'react'
import { OfferCta } from '../../../offers'
import { OfferSearchList } from '../../../search/offer/OfferSearchList'
import ResearchSubscriptionButton from '../../../search/researchSubscription/researchSubscriptionButton'

interface OfferListProps {
  siteStrapiUrl: string
  isResearchSubscriptionButtonActive: boolean
}

export const OfferList = ({
  siteStrapiUrl,
  isResearchSubscriptionButtonActive,
}: OfferListProps) => (
  <div className="relative mx-auto space-y-4 lg:space-y-8">
    <div className="fixed inset-x-0 z-50 flex justify-center bottom-10">
      <ResearchSubscriptionButton
        fromPage="offers"
        strapiUrl={siteStrapiUrl}
        isResearchSubscriptionButtonActive={isResearchSubscriptionButtonActive}
      />
    </div>

    <OfferSearchList />
    <OfferCta />
  </div>
)
